module.exports = "//d274d294w9cx2v.cloudfront.net/577741e64fbecad72426a4727298cdcd07eef839/images/digital-invites.jpg";